import { Link } from 'react-router-dom';
import { usePageTitle } from '../../lib/usePageTitle';
import { AuthLayout } from '../../components/AuthLayout';

/**
 * Cookie policy. PandaCalcio usa SOLO cookie tecnici di sessione:
 * niente banner necessario, niente tracciamento.
 */
export function CookiePage() {
  usePageTitle('Cookie policy');
  return (
    <AuthLayout title="Cookie policy">
      <div className="flex max-w-prose flex-col gap-4 text-ink-800 dark:text-ink-100">
        <p>
          PandaCalcio usa <strong>soltanto cookie tecnici</strong>, indispensabili per il
          funzionamento del servizio. Non usiamo cookie di profilazione, pubblicitari o di terze
          parti: per questo non ti chiediamo nessun consenso con banner.
        </p>

        <h2 className="mt-2 text-xl font-bold">I cookie che usiamo</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-left">
            <caption className="visually-hidden">Elenco dei cookie tecnici utilizzati</caption>
            <thead>
              <tr className="border-b-2 border-ink-300 dark:border-ink-600">
                <th scope="col" className="py-2 pr-3">Nome</th>
                <th scope="col" className="py-2 pr-3">Scopo</th>
                <th scope="col" className="py-2">Durata</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-ink-200 dark:border-ink-800">
                <td className="py-2 pr-3 font-mono text-sm">pc_access</td>
                <td className="py-2 pr-3">Ti mantiene autenticato durante la navigazione</td>
                <td className="py-2">15 minuti</td>
              </tr>
              <tr className="border-b border-ink-200 dark:border-ink-800">
                <td className="py-2 pr-3 font-mono text-sm">pc_refresh</td>
                <td className="py-2 pr-3">Rinnova la sessione senza rifare l’accesso</td>
                <td className="py-2">30 giorni</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Entrambi sono cookie <em>httpOnly</em> e sicuri: non sono leggibili da script e non
          contengono dati personali in chiaro. Eliminandoli dal browser vieni semplicemente
          disconnesso.
        </p>

        <p className="mt-2">
          Vedi anche l’<Link to="/privacy" className="text-panda-700 underline dark:text-panda-300">informativa privacy</Link>.
        </p>
        <p className="text-sm text-ink-600 dark:text-ink-300">Ultimo aggiornamento: 27 agosto 2026.</p>
      </div>
    </AuthLayout>
  );
}
